import React from 'react';

export const Dashboard = (props) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H8V18ZM10 18H16C17.1 18 18 17.1 18 16V9H10V18ZM18 7V2C18 0.9 17.1 0 16 0H10V7H18Z" />
    </svg>
);

export default Dashboard;
